import * as types from './constants';
import store from '../../store';

export const updateLayout = data => (
  { type: types.UPDATE_LAYOUT, payload: data }
);

export const setCriticalError = data => (
  { type: types.SET_CRITICAL_ERROR, payload: data }
);

export const updateMessage = data => (
  { type: types.UPDATE_MESSAGE, payload: data }
);

export const setMessage = (payload, noHide) => {
  const { dispatch } = store;
  dispatch(updateMessage(payload));

  if (!noHide) {
    setTimeout(() => dispatch(updateMessage('')), 3000);
  }
};

export const showAppLoader = () => (
  { type: types.SHOW_LOADER }
);

export const hideAppLoader = () => (
  { type: types.HIDE_LOADER }
);